import FolhaPagamento from "../../components/folha-pagamento/pagamento/FolhaPagamento";

export default function () {
  return <FolhaPagamento />;
}
